import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { ROLE_PUBLIC } from '@router/Routes'
import { useTranslation } from 'react-i18next'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'
import Table from '@ui/component/Table'
import useHtmlRenderer from '@hook/useHtmlRenderer'

const Home = () => {
  const { mission, homePage, missionBillings } = useSelector(state => state.main)
  const { isCompany, isCoOwnership } = mission
  const renderHtml = useHtmlRenderer()
  const [t] = useTranslation(['common', 'form'])
  const navigate = useNavigate()

  const getButtons = () => {
    const buttons = [
      { cssClass: 'citizen', callback: () => navigate(ROLE_PUBLIC['citizenSterilizationCall']), text: isCompany ? t('actions.add_citizen_call') : t('labels.make_call') }
    ]

    if (isCompany && !isCoOwnership) {
      buttons.push({ cssClass: 'company', callback: () => navigate(ROLE_PUBLIC['companySterilizationCall']), text: t('actions.add_company_call') })
    }

    if (!isCompany && isCoOwnership) {
      buttons.push({ cssClass: 'coOwnership', callback: () => navigate(ROLE_PUBLIC['companySterilizationCall']), text: t('actions.add_co_ownership_call') })
    }

    if (isCompany && isCoOwnership) {
      buttons.push({ cssClass: 'establishment', callback: () => navigate(ROLE_PUBLIC['companySterilizationCall']), text: t('actions.add_establishment_call') })
    }

    return buttons
  }

  const renderMissionBillings = () => {
    const thead = <>
      <thead>
        <th>{t(`form:titles.billingType`)}</th>
        <th>{t(`form:labels.min`)}</th>
        <th>{t(`form:labels.max`)}</th>
        <th>{t(`form:labels.cost`)}</th>
        <th>{t(`form:labels.company_cost`)}</th>
        <th>{t(`form:labels.co_ownership_cost`)}</th>
      </thead>
    </>
    const billings = Object.values(missionBillings)
    const billingsList = billings.map(billing => {
      return <>
        <tr key={`${billing.id}-${billing.billingType}`}>
          <td>{t(`labels.${billing.billingType}`)}</td>
          <td>{billing.min}</td>
          <td>{billing.max}</td>
          <td>{billing.cost ? `${billing.cost} €` : '-'}</td>
          <td>{billing.companyCost ? `${billing.companyCost} €` : '-'}</td>
          <td>{billing.coOwnershipCost ? `${billing.coOwnershipCost} €` : '-'}</td>
        </tr>
      </>
    })

    return <>
      {billings.length
        ? <Div cssClass='billings'>
          <h2 className='zone-title'>{t('titles.mission_billings_list')}</h2>
          <Table cssClass='billing-grid is-fullwidth'>
            {thead}
            {billingsList}
          </Table>
        </Div>
        : <></>}
    </>
  }

  return (
    <Div cssClass='home-page'>
      <Div cssClass='home-text'>
        {homePage && renderHtml(homePage.description)}
      </Div>

      {renderMissionBillings()}

      <Div cssClass='home-buttons'>
        <Buttons buttons={getButtons()} />
      </Div>
    </Div>
  )
}

export default Home